import * as locales from '@mui/material/locale';

const defaultLocaleId = 'enUS';

export enum LanguageMenuEnum {
    EN = 'en',
    RO = 'ro',
}

export type SupportedLocales = keyof typeof locales;

export interface LanguageOption {
    localeId: SupportedLocales;
    langCode: string;
    name: string;
}

const getLanguageOptions = () => {
    const languageCodes = Object.keys(LanguageMenuEnum);
    return Object.keys(locales)
        .map((key) => {
            return {
                localeId: key as SupportedLocales,
                langCode: key.substring(0, 2),
                name: key.substring(0, 2).toUpperCase(),
            } as LanguageOption;
        })
        .filter((option) => languageCodes.includes(option.name))
        .sort((a, b) => a.langCode.localeCompare(b.langCode, 'en', { ignorePunctuation: true }));
};

export const languageOptions = getLanguageOptions();

const getLanguageByCode = (langCode: string) =>
    languageOptions.find((o) => o.langCode === langCode);

export const getLanguageName = (langCode: string) => {
    const option = getLanguageByCode(langCode);
    return option?.name || LanguageMenuEnum.EN;
};

export const getLanguageLocale = (langCode: string) => {
    const option = getLanguageByCode(langCode);
    return option?.localeId || (defaultLocaleId as SupportedLocales);
};

export const getLocalization = (locale: SupportedLocales) => locales[locale];
